import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import clearIcon from '../../images/clear-field-icon_b.png';
import editIconActive from '../../images/insight360/edit-icon_active.png';
import InlineEdit from '../common/InlineEdit/InlineEdit';
import { numberWithCommas } from '../../util/CommonUtils';
import * as definitionActions from '../../actions/definitionActions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { DEFINITION_HEADER_LENGTH } from '../../constants';
import Modal from '../common/Modal/Modal';
import SaveDefinitionLabelPopupScreen from '../common/SaveDefinitionLabelPopupScreen';
import {
  SALES_CATALYST_DUPLICATE_DEFINITION_WARNING,
  SALES_CATALYST_DEFINITION_LENGTH_WARNING,
} from '../../messages/messages';

const modalSettingStyle = {
  width: '51%',
  height: '40px',
  left: '24%',
  top: '20%',
};
class SalesCatalystLabelField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInEditMode: false,
      headerLabelUpdateObject: {},
      headerLabelUpdateCallBack: '',
      index: null,
      popupCloseButtonClick: true,
    };
  }

  onModalPopupXButtonClick = () => {
    if (this.state.popupCloseButtonClick) {
      this.state.headerLabelUpdateCallBack(false);
    } else {
      this.setState({
        popupCloseButtonClick: true,
      });
    }
  };

  toggleEditMode = value => {
    this.setState({
      isInEditMode: value,
    });
  };

  validateHeaderLabel = (value, callback) => {
    // check the label max length equal to 64
    const callBackArg = value.length < DEFINITION_HEADER_LENGTH;
    if (callBackArg) {
      const findIndex = this.props.dataList.findIndex(
        data => (data.label === value)
      );
      if (findIndex === -1) {
        callback(true);
      } else {
        callback(false, SALES_CATALYST_DUPLICATE_DEFINITION_WARNING);
      }
    } else {
      callback(false, SALES_CATALYST_DEFINITION_LENGTH_WARNING);
    }
  };

  updateHeaderLabel = (value, callback, index) => {
    const copyOfDataList = _.clone(this.props.dataList);
    const expression = [];
    let definationId = null;
    copyOfDataList.forEach((label, key) => {
      if (key === index) {
        const expressionObj = {
          id: label.expId,
          title: value.trimStart(),
          expression: label.expression,
        };
        expression.push(expressionObj);
        definationId = label.defId;
      }
    });

    const labelUpdateData = {
      defId: definationId,
      defName: '',
      expressions: expression,
    };
    this.setState({
      headerLabelUpdateObject: labelUpdateData,
      headerLabelUpdateCallBack: callback,
      index,
    });

    this.confirmationModal.show();
  };

  findMainAndSubCategory = field => {
    const input = field.split('-');
    let mainCategory = null;
    let subCategory = null;
    switch (input[0]) {
      case 'brand':
        mainCategory = 'brandSelection';
        break;
      case 'pitch':
        mainCategory = 'pitchSelection';
        break;
      default: mainCategory = null;
        break;
    }
    switch (input[1]) {
      case 'aud':
        subCategory = 'audience';
        break;
      case 'subaud':
        subCategory = 'subAudience';
        break;
      case 'compet':
        subCategory = 'competitors';
        break;
      case 'market':
        subCategory = 'market';
        break;
      default: subCategory = null;
        break;
    }
    return {
      mainCategory, subCategory,
    };
  }

  onPersonaHeaderLabelSave = definationObject => {
    const category = this.findMainAndSubCategory(_.clone(this.props.field));
    const headerLabelUpdateObject = _.clone(
      this.state.headerLabelUpdateObject,
    );

    if (
      definationObject.definitionFolderId !==
      headerLabelUpdateObject.defId
    ) {
      headerLabelUpdateObject.defId =
        definationObject.definitionFolderId;
      headerLabelUpdateObject.expressions[0].id = null;
    }
    headerLabelUpdateObject.defName =
      definationObject.definitionFolderName;

    this.props.saveUpdatedDefinitionData(
      headerLabelUpdateObject,
      this.state.headerLabelUpdateCallBack,
      this.state.index,
      category
    );
    this.setState(
      {
        popupCloseButtonClick: false,
      },
      () => {
        this.confirmationModal.hide();
      },
    );
  };

  render() {
    const { data, deleteHandler, index, field } = this.props;
    return (
      <div className="input-label-field">
        <Modal
          title=""
          ref={node => (this.confirmationModal = node)}
          dialogStyles={modalSettingStyle}
          afterClose={this.onModalPopupXButtonClick}
        >
          <div className="text-center">
            <div className="">
              <SaveDefinitionLabelPopupScreen
                definitionTree={this.props.definitionTree}
                personaHeaderLabelUpdateObject={
                  this.state.headerLabelUpdateObject
                }
                onPersonaHeaderLabelSave={this.onPersonaHeaderLabelSave}
                productNo={this.props.productNo}
              />
            </div>
          </div>
        </Modal>
        {
          data.label ?
            <InlineEdit
              textVal={data.label}
              editBlockWidth="100%"
              editBlockTopMargin="1%"
              icon={editIconActive}
              editFunction={this.toggleEditMode}
              updateFn={this.updateHeaderLabel}
              validateFn={this.validateHeaderLabel}
              defaultViewWidth="95%"
              index={index}
            />
            : data.label
        }
        {data.sample && (!this.state.isInEditMode) && <div className="sample-weighted-content">
          <div className="bold">SAMPLE: <span className="red-text">{numberWithCommas(
            Math.round(data.sample))}</span> | WEIGHTED: <span className="red-text">{numberWithCommas(
              Math.round(data.weighted))}</span></div>
        </div>}
        {data.sample && (!this.state.isInEditMode) && <div className="clear-icon" onClick={e => deleteHandler(e, index, field)}><img src={clearIcon} alt="clear-icon" /></div>}
      </div>
    );
  }
}

SalesCatalystLabelField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object]),
  deleteHandler: PropTypes.func,
  index: PropTypes.number,
  field: PropTypes.string,
  productNo: PropTypes.number,
  saveUpdatedDefinitionData: PropTypes.func,
  definitionTree: PropTypes.arrayOf(PropTypes.object),
  dataList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object]),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    studySource: typeof state.study.salesCatalystStudy !== 'undefined' &&
    typeof state.study.salesCatalystStudy.ss !== 'undefined' &&
    state.study.salesCatalystStudy.ss === 'SIMMONS' ? 1 : 2,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const refreshDefinationdata = () => {
    dispatch(
      definitionActions.getDefinitionTreeLoad(
        stateProps.loginResponse.data.token,
        stateProps.studySource,
        stateProps.activeAccountId,
        stateProps.productNo,
      ),
    );
  };

  const saveUpdatedDefinitionData = (updatedlabelData, callbackFn, index, category) => {
    dispatch(
      salesCatalystActions.saveDataToDefinitionFolder(
        stateProps.loginResponse.data.token,
        stateProps.loginResponse.data.uid,
        stateProps.activeAccountId,
        stateProps.productNo,
        updatedlabelData,
        callbackFn,
        refreshDefinationdata,
        index,
        category
      ),
    );
  };

  return { ...stateProps, ...ownProps, saveUpdatedDefinitionData, };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystLabelField);
